import { render, staticRenderFns } from "./Provera.vue?vue&type=template&id=7fe74598&"
import script from "./Provera.vue?vue&type=script&lang=js&"
export * from "./Provera.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports